const RiskProfilePublic = () => import('@/pages/RiskProfilePublic.vue');

const routes = [
  {
    path: '/risk-profile/',
    meta: { title: 'Risk Profile' },
    component: RiskProfilePublic,
  },
];

export default routes;
